<script setup>
import footerLogos from "./footerLogos.vue";
import Nav from "./Nav.vue";
import Menu from "./Menu.vue";
import { useUserStore } from "@/stores/user";


const userStore = useUserStore();

</script>
<template>
  <div>
    <Nav />
    <div class="dashboard container-fluid" style="padding-bottom: 150px;">
        <!-- <Logos /> -->
        <Menu />
        <router-view></router-view>
        <footer-logos />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.dashboard {
  margin-top: 50px;
  padding-top: 20px;
  
}
@media(max-width:768px){
}
@media(min-width: 768px) {
  .dashboard {
    padding-inline: 55px;
  }
  
}

</style>
